import { Component, OnInit } from '@angular/core';
import {Router} from '@angular/router';
import {SideNavBarVisibilityService} from '../../services/side-nav-bar-visibility.service';
import {AdminDashboardService} from '../../services/admin-dashboard.service';
import {NotificationService} from '../../services/notification.service';
import {ZPNotification} from '../../models/zpnotification';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { ThemeService } from 'src/app/theme/theme-service.service';

@Component({
  selector: 'app-suggestion-rules',
  templateUrl: './suggestion-rules.component.html',
  styleUrls: ['./suggestion-rules.component.scss']
})
export class SuggestionRulesComponent implements OnInit {
  public list = [];
  public section = "suggestions_config";
  public lineState = [];
  constructor(
              private router: Router, 
              public sideNavBarVisibilityService: SideNavBarVisibilityService,
              private api: AdminDashboardService, 
              private notifications:NotificationService, public themeService: ThemeService) { }

  async ngOnInit() {
    this.reloadList();
  }

  onDrop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.list, event.previousIndex, event.currentIndex);
    this.list.forEach((list, idx) => {
      list.orderPlacement = idx + 1;
    });
  }

  async reloadList(){
    this.list = await this.api.getList(this.section);
    // make sure all items in the list have an orderPlacement value.
    this.list = this.list.sort((a,b)=>{
      return parseInt(a.orderPlacement) - parseInt(b.orderPlacement);
    });
    let i = 0;
    this.list.forEach((item)=>{
      if(!item.hasOwnProperty('orderPlacement')){
        i = i + 1;
        item.orderPlacement = i;
      }else{
        i = parseInt(item.orderPlacement);
      }
    });
  }

  async saveItem(index){
    let item = this.list[index];
    let result = await this.api.putItem(this.section,item);
    if(result && result.success){
      this.notifications.changeMessage(new ZPNotification("Item Saved"))
      this.toggleSection(index);
      this.reloadList();
    }else{
      this.notifications.changeMessage(new ZPNotification("Save failed"))
    }
  }

  async deleteItem(index) {
    let item = this.list[index];
    let success = await this.api.deleteItem(this.section,item);
    if (success) {
      this.notifications.changeMessage(new ZPNotification("Item has been deleted"))
      this.reloadList();
    } else {
      this.notifications.changeMessage(new ZPNotification("Item has been deleted"))
    }
  }

  toggleSection(index){
    if(this.lineState[index]){
      this.lineState[index] = false;
    }else{
      this.lineState[index] = true;
    }
  }
  addNew(){
    let current = this.list.length;
    this.list.push({title:"New Step",copy:"",buttonCopy:"",buttonLink:"",action:"",dropdown:"",image:""});
    this.lineState[current] = true;
  }

}
